<template>
  <div class="page-content">
    <page-template
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
    ></page-template>
  </div>
</template>

<script>
  import pageTemplate from '@/components/template/pageTemplate';
  import api from '@/config/api';

  export default {
    components: {
      pageTemplate

    },
    data() {
      return {
        dialogVisibility: false,
        // 高级搜索条件
        searchOptions: {
          simple: [
            {label: '', prop: 'phone', type: 'input', ifFuzzy: true, placeholder: '请输入手机号'}
          ],
          complex: [
            {label: "选择日期", prop: "CreateDttm", type: "dateTimeRangeButton", dateType: "datetime", span: 24},
            {
              label: "门店名称",
              type: "select",
              prop: "storeId",
              span: 12,
              isHasAll: true,
              data: [],
              hidden: this.$utils.getSysUser().storeId ? true : false,
              url: api.store.store,
            },
            {
              label: "业务类型",
              type: "select",
              prop: "type",
              span: 12,
              data: this.$utils.getCacheStatus("ntSmsConsumeRecode.type")
            },]
        },
        // 表格信息配置
        tableOptions: {
          indexShow: true, // 是否显示索引
          columns: [
            {label: '门店', prop: 'storeName', width: '120', align: 'center'},
            {label: '联系人', prop: 'relateName', width: '120', align: 'center'},
            {label: '手机号', prop: 'phone', width: '120', align: 'center'},
            {
              label: '业务类型',
              prop: 'type',
              width: '120',
              align: 'center',
              enumData: this.$utils.getCacheStatus("ntSmsConsumeRecode.type")
            },
            {label: '内容', prop: 'smsStr', width: '120', align: 'center'},
            {label: '发送时间', prop: 'createDttm', width: '200', align: 'center'},
          ],
          url: api.notify.smsConsumeRecord
        },
      };
    },
    created() {
    },
    methods: {}
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/apply/notify/SmsConsumeRecord.vue